import { render } from "./IntegrationStatusMatrix.vue?vue&type=template&id=15d3a4a4"
import script from "./IntegrationStatusMatrix.vue?vue&type=script&lang=js"
export * from "./IntegrationStatusMatrix.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__